
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 17.05","aria-label":"Back"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.48 17.05A71.32 71.32 0 000 8.48 97.84 97.84 0 008.3 0l.59.49a61.35 61.35 0 01-4.06 8 45.76 45.76 0 014.28 8.12zm8.84 0a90.24 90.24 0 00-8.39-8.57A108.65 108.65 0 0017.1 0l.63.4a74.39 74.39 0 01-4.06 8.08A46.36 46.36 0 0118 16.6z"}})])
          )
        }
      }
    